import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { map } from 'rxjs';
import { Api } from 'src/app/core/api/Api';
import { downloadCSVFromRequest } from 'src/app/core/common/csv.download';

@Injectable({
  providedIn: 'root',
})
export class AdminUsersService {
  constructor(private http: HttpClient) {}

  fetchUsers() {
    return this.http.get(Api.Users);
  }

  fetchCSV() {
    return this.http.get(Api.UsersAsCsv, {
      responseType: 'text',
      observe: 'response',
    });
  }

  createUser(user: any) {
    return this.http.post(Api.CreateUser, user, { responseType: 'text' });
  }

  deleteUser(id: string) {
    return this.http.delete(`${Api.DeleteUser}/${id}`);
  }

  sendPasswordMail(id: string) {
    return this.http.put(`${Api.SendPasswordMail}/${id}`, {});
  }

  downloadCSV() {
    return this.fetchCSV().pipe(map(downloadCSVFromRequest));
  }
}
